
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.095 5.2a2.011 2.011 0 110 4.02h-2.314L8.032 19.25v.023H4.011a2.012 2.012 0 010-4.022h2.293L16.074 5.2h4.021zM10.043 9.681l-2.011 2.07V8.214a1.006 1.006 0 012.01 0v1.467zM9.037 5a1.005 1.005 0 110 2.01 1.005 1.005 0 010-2.01zm6.082 9.786l2.844-2.844 1.421 1.42-2.844 2.845-1.42-1.421zm4.976-3.555v2.837l-2.837-2.837h2.837z"}})])
          )
        }
      }
    